import { useQuery } from '@tanstack/react-query';
import { getLeadtimeAnalysis, type LeadtimeWindow } from '../orders.api';

export function useLeadtimeAnalysis(serviceCode: string, window: LeadtimeWindow = {}, enabled = true) {
  return useQuery({
    queryKey: ['orders', 'analytics', 'leadtime', serviceCode, window.from ?? null, window.to ?? null],
    queryFn: () => getLeadtimeAnalysis(serviceCode, window),
    enabled: enabled && serviceCode !== '',
    staleTime: 60 * 1000,
  });
}
